
































import { Component, Vue } from 'vue-property-decorator';
import UserService from '@/services/user';
import User from '@/entities/User';

@Component
export default class Users extends Vue {
    userService = new UserService();

    get users(): User[] {
        return this.userService.list;
    }
}
